import { cn } from "../../../../lib/utils";

interface ImpactChangeDisplayProps {
  change: number;
}

const ImpactChangeDisplay = ({ change }: ImpactChangeDisplayProps) => {
  if (change === 0) {
    return <span className="tw-block tw-text-center tw-text-muted-foreground">—</span>;
  }

  const color = change < 0 ? "tw-text-primary" : "tw-text-destructive";
  const sign = change > 0 ? "+" : "";

  return (
    <span className={cn("tw-block tw-text-center tw-font-medium", color)}>
      {sign}
      {change.toFixed(1)}%
    </span>
  );
};

export default ImpactChangeDisplay;
